import { atom, selector } from "recoil"
import { analyticsWrap } from "src/tags/analytics"

export const deviceTokenOptInState = atom<boolean>({
  key: "atoms/account/deviceTokenOptInState",
  default: true,
})

export const deviceTokenOptInBooleanState = selector<boolean>({
  key: "selectors/account/deviceTokenOptInBooleanState",
  get: ({ get }) => {
    return get(deviceTokenOptInState)
  },
  set: ({ set }, newValue) => {
    set(deviceTokenOptInState, newValue)
    analyticsWrap.setUserProperties({
      optIn: newValue ? "true" : "false",
    })
  },
})
